import { useState } from "react";

export type UserSettings = {
    generalOptions?: {
        useAppPrinter?: boolean;
        useBluetoothPrinter?: boolean;
        printerSize?: AppGeneralState["printerSize"];
        autoPrint?: boolean;
        selectAllPayablesByDefault?: boolean;
    };
    filters?: {
        showOlderOrders?: boolean;
        showDeliveredOrders?: boolean;
        showPaidOrders?: boolean;
    };
    display?: {
        ordersListViewType?: "list" | "grid";
    };
    settings?: {
        print?: {
            printMethod?: string; // ex.: "bluetooth"
            autoPrint?: boolean;
            printerSize?: AppGeneralState["printerSize"];
        };
        payment?: {
            selectAllPayablesByDefault?: boolean;
        };
        ui?: {
            showKeyboard?: boolean;
        };
    };
};

export type UseUserSettingsResult = {
    userSettings: UserSettings;
    saveUserSettings: (details: UserSettings) => void;
};

const isPlainObject = (value: unknown): value is Record<string, unknown> => (
    typeof value === "object" &&
    value !== null &&
    !Array.isArray(value)
);

const getUserSettings = (): UserSettings => {
    const userSettingsString = localStorage.getItem("userSettings");

    if (!userSettingsString) {
        return {};
    }

    try {
        const parsedValue: unknown = JSON.parse(userSettingsString);
        return isPlainObject(parsedValue) ? parsedValue as UserSettings : {};
    } catch {
        return {};
    }
};

export default function useUserSettings(): UseUserSettingsResult {
    const [userSettings, setUserSettings] = useState<UserSettings>(getUserSettings);

    const saveUserSettings = (details: UserSettings) => {
        const { generalOptions: _legacyGeneralOptions, ...nextUserSettings } = details;

        localStorage.setItem("userSettings", JSON.stringify(nextUserSettings));
        setUserSettings(nextUserSettings);
    };

    return {
        saveUserSettings,
        userSettings,
    };
}
